// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"styles_carouselWrapper__NDmoL","contentWrapper":"styles_contentWrapper__qd-8k","productButton":"styles_productButton__h7DdA"};